import { render } from "./ScreenShot.vue?vue&type=template&id=0d8ea696&scoped=true"
import script from "./ScreenShot.vue?vue&type=script&lang=js"
export * from "./ScreenShot.vue?vue&type=script&lang=js"

import "./ScreenShot.vue?vue&type=style&index=0&id=0d8ea696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8ea696"]])

export default __exports__